import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { CompanyCreateSuccessPage as CompanyCreateSuccessPageComponent } from './CompanyCreateSuccessPage.component';
import { DEFAULT_COMPANIES_SEARCH } from '@/features/companies/companies-list/companies-search.schema';

const AUTO_REDIRECT_MS = 2000;

export default function CompanyCreateSuccessPage() {
  const navigate = useNavigate();

  useEffect(() => {
    const handle = window.setTimeout(() => {
      void navigate({ to: '/', search: DEFAULT_COMPANIES_SEARCH });
    }, AUTO_REDIRECT_MS);
    return () => window.clearTimeout(handle);
  }, [navigate]);

  return (
    <CompanyCreateSuccessPageComponent
      onEnterWorkspace={() => {
        // TODO: navigate to the newly-created workspace detail when route lands.
        void navigate({ to: '/', search: DEFAULT_COMPANIES_SEARCH });
      }}
      onBackToCompanies={() => {
        void navigate({ to: '/', search: DEFAULT_COMPANIES_SEARCH });
      }}
    />
  );
}
